import { useCallback, useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { jestPolska } from '../kraj'
import { LIMITY_BEZ_KONTA, zostalo, zuzyj } from '../lib/limitBezKonta'

/**
 * Limit użyć narzędzia bez konta (FE-06, lib/limitBezKonta). Zalogowany nie ma limitu; dopóki sesja się ustala,
 * też nie liczymy, żeby nie zabrać użycia komuś, kto jest zalogowany. Poza Polską kont nie ma (logowanie tylko
 * po polsku, AuthContext), więc w wersji krajowej limitów też nie ma.
 *
 * `sprobuj()` przy działaniu użytkownika (wysłanie formularza, klik w wykres): `true` = można (i użycie
 * zapisane), `false` = limit wyczerpany, pokaż `OknoRejestracji`. `bezKonta`: ekran ma pokazać wersję bez
 * konta (np. jeden zestaw w asystencie).
 */
export const useLimitBezKonta = (narzedzie) => {
  const { isAuthenticated, loading } = useAuth()
  const [, setWersja] = useState(0)
  const bezLimitu = Boolean(!jestPolska || isAuthenticated || loading)
  const pozostalo = bezLimitu ? Infinity : zostalo(narzedzie)

  const sprobuj = useCallback(() => {
    if (bezLimitu) return true
    const udalo = zuzyj(narzedzie)
    setWersja((w) => w + 1)
    return udalo
  }, [bezLimitu, narzedzie])

  return {
    bezLimitu,
    bezKonta: !bezLimitu,
    limit: LIMITY_BEZ_KONTA[narzedzie],
    zostalo: pozostalo,
    wyczerpany: !bezLimitu && pozostalo <= 0,
    sprobuj,
  }
}

export default useLimitBezKonta
